var DashboardPresetService = function () {
  var dashboardPresets = []
  var dashboardPresetsById = []

  return {
    getDashboardPresets: function () {
      return dashboardPresets
    },
    getDashboardPresetsById: function (id) {
      return dashboardPresetsById[id]
    },

    setDashboardPresets: function (_dashboardPresets) {
      dashboardPresets = _dashboardPresets
      dashboardPresets.forEach(function (dashboardPreset) {
        dashboardPresetsById[dashboardPreset.Id] = dashboardPreset
      })

      // $rootScope.$broadcast('setDashboardPresets', dashboardPresets);
    } /* ,
    updateDashboardPreset: function (_dashboardPreset) {
      return new Promise(function (resolve, reject) {
        DashboardPreset.update(_dashboardPreset).$promise.then(function (result) {
          resolve()
        }, function (error) {
          reject(error)
        })
      })
    },
    insertDashboardPreset: function (_dashboardPreset) {
      return new Promise(function (resolve, reject) {
        DashboardPreset.save(_dashboardPreset).$promise.then(function (result) {
          var dashboardPreset = result
          dashboardPresets.push(dashboardPreset)
          dashboardPresetsById[dashboardPreset.Id] = dashboardPreset

          resolve(dashboardPreset)
        }, function (error) {
          reject(error)
        });
      });
    },
    deleteDashboardPreset: function (_dashboardPreset) {
      return new Promise(function (resolve, reject) {
        DashboardPreset.delete({ id: _dashboardPreset.Id }).$promise.then(function (result) {
          var idx = dashboardPresets.map(function (x) { return x.Id; }).indexOf(_dashboardPreset.Id)
          dashboardPresetsById.splice(_dashboardPreset.Id, 1)
          dashboardPresets.splice(idx, 1)

          resolve()
        }, function (error) {
          reject(error)
        })
      })
    } */
  }
}

export default new DashboardPresetService()



// WEBPACK FOOTER //
// ./src/services/DashboardPresetService.js